<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToMyProjectV2()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">My Project</h3>
                            </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end" *ngIf="this.isPMOLeadORManager || this.isPMOAdmin">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createTask" >
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteSaleTaskv2"
                                    (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div class="add-btn">
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createTask" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex" *ngIf="!this.parentProjectId">
                            <h3><a (click)="openProjectTab('myparameter-v2')">Details</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-v2')">Sub-Project</a></h3>
                            <h3><a class="active">Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resource-v2')">Resources</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('partlist')">Part List</a></h3>
                        </div>
                        <div class="title col-sm-6 d-flex" *ngIf="this.parentProjectId">
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-projectform-v2')">Sub-Project</a></h3>
                            <h3><a class="active">Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resource-v2')">Resources</a></h3>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: 620px;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>


<!-- Delete an item -->
<div class="modal fade" id="deleteSaleTaskV2" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDelete" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteProjectTaskListV2()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Create new createTask -->
<div class="modal fade bd-example-modal-lg" id="createTask" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="taskForm">
                <div class="modal-header">
                    <h5 class="modal-title">Task</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="projectV2Name" disabled required>
                                    <label class="floating-label-special">Project Name</label>
                                    <i class="ri-file-list-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input" *ngIf="this.modeAction === 1">
                                <div class="input-item no-overflow">
                                    <ng-select 
                                        formControlName="taskOwnerName" 
                                        [items]="taskOwnerDropdown"  
                                        [notFoundText]="'No employees found'"  
                                        [multiple]="true"  
                                        placeholder="Select Employee" 
                                        style="width: 100%; z-index: 1; position: relative;">
                                    </ng-select>
                                    <label class="floating-label-special">Resource Name*</label>
                                    <i class="ri-user-3-line"></i>
                                </div>
                                <mat-error *ngIf="f.taskOwnerName.touched && f.taskOwnerName.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.taskOwnerName.errors.required">TaskOwner Name is required</mat-error>
                                </mat-error>
                            </div>
                            <div class="input" *ngIf="this.modeAction === 2">
                                <div class="input-item">
                                    <input type="text" formControlName="taskOwnerName" disabled required>
                                    <label class="floating-label-special">Resource Name*</label>
                                    <i class="ri-user-3-line"></i>
                                </div>
                                <mat-error *ngIf="f.taskOwnerName.touched && f.taskOwnerName.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.taskOwnerName.errors.required">Resource Name is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="projectV2TaskName">
                                        <option value="" disabled>Select Task Name</option>
                                        <option *ngFor="let task of taskList" value="{{task}}">{{task}}</option>
                                    </select>
                                    <label class="floating-label-special">Task Name*</label>
                                    <i class="ri-shield-user-line"></i>
                                </div>
                                <mat-error *ngIf="f.projectV2TaskName.touched && f.projectV2TaskName.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.projectV2TaskName.errors.required">ProjectTask Name is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="partList">
                                        <option value="" disabled>Select Part List</option>
                                        <option *ngFor="let pl of partList" value="{{pl}}">{{pl}}</option>
                                    </select>
                                    <label class="floating-label-special">Part List*</label>
                                    <i class="ri-task-line"></i>
                                </div>
                                <mat-error *ngIf="f.partList.touched && f.partList.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.partList.errors.required"> PartList is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="startDate" min="{{this.minStartDate}}" max="{{this.minEndDate}}">
                                    <label class="floating-label-special">Start Date*</label>
                                    <i class="ri-calendar-todo-line"></i>
                                </div>
                                <mat-error *ngIf="f.startDate.touched && f.startDate.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.startDate.errors.required">Start Date is required</mat-error>
                                  </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="endDate" min="{{this.minStartDate}}" max="{{this.minEndDate}}">
                                    <label class="floating-label-special">End Date*</label>
                                    <i class="ri-calendar-event-line"></i>
                                </div>
                                <mat-error *ngIf="f.endDate.touched && f.endDate.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.endDate.errors.required">End Date is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="plannedStartDate">
                                    <label class="floating-label-special">Planned Start Date</label>
                                    <i class="ri-calendar-todo-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="plannedEndDate">
                                    <label class="floating-label-special">Planned End Date</label>
                                    <i class="ri-calendar-event-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="predecessorProjectV2TaskName">
                                        <option value="" disabled>Select Predecessor Task</option>
                                        <option *ngFor="let task of taskDropdownList" value="{{task}}">{{task}}</option>
                                     </select>
                                    <label class="floating-label-special">Predecessor task</label>
                                    <i class="ri-file-list-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="successorProjectV2taskName">
                                        <option value="" disabled>Select Successor Task</option>
                                        <option *ngFor="let task of taskDropdownList" value="{{task}}">{{task}}</option>
                                     </select>
                                    <label class="floating-label-special">Successor task</label>
                                    <i class="ri-file-list-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="estimatedHours">
                                    <label class="floating-label-special">Estimate Time in Hours(ex. 10.5)</label>
                                    <i class="ri-timer-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="completionPercentage">
                                    <label class="floating-label-special">Percent Work Completed(ex. 25 will be considered as 25%)</label>
                                    <i class="ri-timer-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                  <label class="floating-label floating-label-special">Status*</label>
                                  <select formControlName="status" placeholder="status">
                                    <option value="" disabled selected>Select Status</option>
                                    <option value="open">Open</option>
                                    <option value="close">Close</option>
                                  </select>
                                  <i class="ri-phone-line"></i>
                                </div>
                                <mat-error *ngIf="f.status.touched && f.status.invalid" class="alert alert-danger">
                                    <mat-error *ngIf="f.status.errors.required">Status is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                  <label class="floating-label floating-label-special">Planned Status</label>
                                  <select formControlName="status" placeholder="plannedStatus">
                                    <option value="" disabled selected>Select Status</option>
                                    <option value="open">Open</option>
                                    <option value="close">Close</option>
                                  </select>
                                  <i class="ri-phone-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="input">
                              <div class="input-item">
                                <textarea name="" id="" cols="12" rows="3" formControlName="description"></textarea>
                                <label class="floating-label-special">Description</label>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeTaskModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="!taskForm.valid" *ngIf="modeAction === 1" (click)="createProjectTask()">Create</button>
                    <button type="button" class="btn btn-primary" [disabled]="!taskForm.valid" *ngIf="modeAction === 2" (click)="updateProjectTask()">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>